import React, { useState } from 'react';
import { ExternalLink, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

import { DraftConflictError, ProductionPreviewUnavailableError, apiErrorMessage } from '../api';

export function ProductionPreviewButton({ websiteId, onPreview }: { websiteId: string; onPreview: () => Promise<void> }) {
  const [busy, setBusy] = useState(false);

  const open = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await onPreview();
    } catch (error) {
      if (error instanceof ProductionPreviewUnavailableError) {
        toast.error('Production preview niet geconfigureerd', { description: error.message });
      } else if (error instanceof DraftConflictError) {
        toast.error('Preview kon niet worden gemaakt', { description: error.message });
      } else {
        toast.error(apiErrorMessage(error, 'Production preview kon niet worden geopend.'));
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={() => void open()}
      disabled={busy}
      data-testid="sites-preview-production"
      title={`Production preview van ${websiteId}`}
      className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-3.5 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800 disabled:opacity-60"
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ExternalLink className="h-4 w-4" />}
      <span className="hidden sm:inline">Preview</span>
    </button>
  );
}
